export const iconFontAwesomeUsersPeopleWheelchairMove = (
	<i className="fa-solid fa-wheelchair-move"></i>
);
